import React from 'react';
import { observer } from 'mobx-react';

import { Button, Label, Loader, ProgressBar } from 'ui';

interface Props {
  isLoading?: boolean;
  isUploading?: boolean;
  isUploaded?: boolean;
  isFailed?: boolean;
  errorCode?: 'file_too_big' | null;
  percent?: number;
  fileName?: string;
  url?: string;
  onRetry?: () => void;
  onRemove: () => void;
}

function FileItemUI({
  fileName,
  url,
  isLoading,
  isUploaded = true,
  isFailed,
  errorCode,
  isUploading,
  percent,
  onRemove,
  onRetry,
}: Props) {
  return (
    <div className="rounded py-2 text-sm">
      <div className="flex items-center justify-between gap-4">
        {/* eslint-disable-next-line no-nested-ternary */}
        {isLoading ? (
          <Loader size="tiny" />
        ) : url ? (
          <a href={url} target="_blank" rel="noopener noreferrer" className="truncate">
            <Button link fluid>
              <div className="truncate font-medium">{fileName}</div>
            </Button>
          </a>
        ) : (
          <div className="truncate font-medium">{fileName}</div>
        )}

        <div className="flex justify-center gap-8">
          <span className="whitespace-nowrap text-gray-500">
            {isUploading && percent !== undefined && <span>{`${Math.floor(percent)}%`}</span>}
            {isUploaded && <Label color="green">{gettext('Uploaded')}</Label>}
            {isFailed && !errorCode && <Label color="red">{gettext('Failed')}</Label>}
            {errorCode === 'file_too_big' && <Label color="red">{gettext('File should be smaller than 100MB')}</Label>}
          </span>
          <div className="flex items-center gap-2">
            {isFailed && errorCode !== 'file_too_big' && <Button link negative icon="refresh" onClick={onRetry} />}
            <Button grayLink link icon="x" onClick={onRemove} />
          </div>
        </div>
      </div>

      {!isUploaded && (
        <div className="mt-1">
          <ProgressBar failed={isFailed} progress={percent} done={isUploaded} />
        </div>
      )}
    </div>
  );
}

export default observer(FileItemUI);
